import { Badge } from "../ui/badge";

export const STATUS_META = {
  ONLINE: { label: "Online", dot: "bg-emerald-500", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/30" },
  BUSY: { label: "Busy", dot: "bg-blue-500 animate-pulse", cls: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/30" },
  IDLE: { label: "Idle", dot: "bg-slate-400", cls: "bg-slate-500/10 text-slate-600 dark:text-slate-300 border-slate-500/30" },
  ERROR: { label: "Error", dot: "bg-red-500", cls: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/30" },
  DISABLED: { label: "Disabled", dot: "bg-muted-foreground/40", cls: "bg-muted text-muted-foreground border-border line-through" },
};
export const TASK_STATUS_CLS = {
  completed: "text-emerald-700 dark:text-emerald-400 border-emerald-500/30",
  failed: "text-red-700 dark:text-red-400 border-red-500/30",
  rejected: "text-amber-700 dark:text-amber-400 border-amber-500/30",
  RUNNING: "text-blue-700 dark:text-blue-400 border-blue-500/30",
};

export const fmtTs = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtMs = (ms) => (ms == null ? "—" : ms >= 1000 ? `${(ms / 1000).toFixed(1)} s` : `${ms} ms`);
export const fmtPct = (r) => (r == null ? "—" : `${Math.round(r * 100)}%`);
export const fmtConf = (c) => (c == null ? "—" : Number(c).toFixed(2));

export const StatusPill = ({ status, testId }) => {
  const m = STATUS_META[status] || STATUS_META.IDLE;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[10px] font-mono-tech uppercase tracking-wider ${m.cls}`} data-testid={testId}>
      <span className={`h-1.5 w-1.5 rounded-full ${m.dot}`} />{m.label}
    </span>
  );
};

export const TaskStatusBadge = ({ status, testId }) => (
  <Badge variant="outline" className={`text-[10px] font-mono-tech uppercase ${TASK_STATUS_CLS[status] || ""}`} data-testid={testId}>{status}</Badge>
);

export const Field = ({ label, children, testId }) => (
  <div className="space-y-0.5" data-testid={testId}>
    <p className="text-[11px] uppercase tracking-widest text-muted-foreground">{label}</p>
    <div className="text-sm break-words">{children ?? "—"}</div>
  </div>
);
